import { useState } from 'react';

const navItems = [
  { id: 'trending', label: '今日热榜', icon: 'ri-fire-line' },
  { id: 'feed', label: '最新爆料', icon: 'ri-flashlight-line' },
  { id: 'timeline', label: '今日速递', icon: 'ri-timer-line' },
  { id: 'faq', label: '吃瓜问答', icon: 'ri-question-answer-line' },
  { id: 'about', label: '关于瓜田', icon: 'ri-information-line' },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 items-center justify-between gap-3 px-4 md:h-[68px] md:px-6">
        <a href="#top" className="group flex items-center gap-2 whitespace-nowrap" aria-label="瓜田网首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-2xl bg-primary-500 text-lg leading-none transition group-hover:-rotate-12">🍉</span>
          <span className="font-heading text-xl md:text-2xl text-primary-600">瓜田网</span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              className="flex items-center gap-1.5 rounded-full px-4 py-2 text-sm text-foreground-700 transition hover:bg-primary-100 hover:text-primary-700"
            >
              <i className={`${n.icon} text-[15px]`} aria-hidden="true" />
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600 sm:inline-flex"
          >
            去投稿吃瓜
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-xl text-foreground-800 transition hover:bg-primary-100 md:hidden"
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-3-line'} text-2xl`} aria-hidden="true" />
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200/80 bg-background-50 px-4 py-3 md:hidden" aria-label="移动端导航">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((n) => (
              <a
                key={n.id}
                href={`#${n.id}`}
                onClick={() => setOpen(false)}
                className="flex items-center gap-2 rounded-xl bg-background-100 px-3 py-3 text-sm text-foreground-800"
              >
                <i className={`${n.icon} text-primary-600`} aria-hidden="true" />
                {n.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="col-span-2 flex items-center justify-center gap-2 rounded-xl bg-primary-500 px-3 py-3 text-sm font-medium text-background-50"
            >
              <i className="ri-send-plane-line" aria-hidden="true" />
              去投稿吃瓜
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}